<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-customer-service`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.006 31H7a3 3 0 01-2.995-2.824L4 28v-6a3 3 0 012.824-2.995L7 19h1.007l.003-.225C8.18 10.59 15.14 4 24 4c8.942 0 15.94 6.713 15.987 15H41a3 3 0 013 3v6a3 3 0 01-3 3h-1.115c-.725 8.977-5.304 12.573-12.508 12.964A1.94 1.94 0 0127 44h-6a2 2 0 01-2-2v-4a2 2 0 012-2h6a2 2 0 012 2v1.374c4.627-.725 6.986-3.542 6.986-11.006V23h.005l.001-3.918C35.992 13.206 30.962 8 24 8c-6.963 0-12.001 5.207-12.001 11.082l-.001 2.859L12 22l-.001 7a2 2 0 01-2 2H7h1.006z"/></svg>
</template>
<script>

export default {
  name: 'IconCustomerService',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
